import React, { useEffect, useLayoutEffect } from "react";
import { useInView } from 'react-intersection-observer';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Lines = [
    "No Account managers,",
    "No website design,",
    "No google ads,",
    "no social ads,",
    "no seo,",
    "no b*llsh*t"

]


function Logo(props) {
    return (
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0.7 0.6 15 213.01"
        {...props}
      >
        <path
          d="M.7 7.49c0-1.44.313-2.673.94-3.7.633-1.027 1.513-1.817 2.64-2.37C5.407.873 6.713.6 8.2.6s2.793.273 3.92.82c1.127.553 2.003 1.343 2.63 2.37.633 1.027.95 2.26.95 3.7 0 1.44-.317 2.673-.95 3.7-.627 1.033-1.503 1.823-2.63 2.37-1.127.553-2.433.83-3.92.83s-2.793-.277-3.92-.83c-1.127-.547-2.007-1.337-2.64-2.37C1.013 10.163.7 8.93.7 7.49zm2.27 0c-.007.967.207 1.77.64 2.41.433.647 1.043 1.13 1.83 1.45.787.327 1.707.49 2.76.49 1.053 0 1.967-.163 2.74-.49.78-.32 1.387-.803 1.82-1.45.433-.64.657-1.443.67-2.41.007-.967-.207-1.77-.64-2.41-.433-.64-1.043-1.123-1.83-1.45-.787-.32-1.707-.48-2.76-.48-1.053 0-1.97.16-2.75.48-.773.32-1.377.8-1.81 1.44-.433.647-.657 1.453-.67 2.42zM1 16.38h14.4v5.95c0 .14-.007.32-.02.54-.007.22-.027.424-.06.61-.127.834-.403 1.52-.83 2.06a3.8 3.8 0 01-1.62 1.21c-.647.267-1.367.4-2.16.4-1.173 0-2.183-.296-3.03-.89-.84-.593-1.36-1.503-1.56-2.73l-.09-1.03v-3.71H1v-2.41zm0 8.27l5.86-2.84.54 2.45L1 27.38v-2.73zm7.28-5.86v3.44c0 .134.007.284.02.45.013.167.04.32.08.46.1.4.277.714.53.94.253.234.54.397.86.49.32.1.633.15.94.15.307 0 .62-.05.94-.15.327-.093.617-.256.87-.49.253-.226.43-.54.53-.94.04-.14.063-.293.07-.46.013-.166.02-.316.02-.45v-3.44H8.28zM1 28.585l14.4 4.54v3.53L1 41.194v-2.48l12.92-4.12v.54L1 31.064v-2.48zm3.12 2.53h2.25v7.56H4.12v-7.56zM1 43.002h14.4v2.44l-10.15 6.68H15.4v2.44H1v-2.44l10.15-6.68H1v-2.44zM.7 63.297c0-.933.163-1.81.49-2.63.333-.813.82-1.53 1.46-2.15.64-.613 1.423-1.093 2.35-1.44.933-.347 2-.52 3.2-.52 1.573 0 2.917.293 4.03.88 1.12.587 1.977 1.39 2.57 2.41.6 1.02.9 2.17.9 3.45 0 1.773-.413 3.177-1.24 4.21-.82 1.04-1.973 1.743-3.46 2.11l-.39-2.46c.853-.273 1.533-.72 2.04-1.34.513-.62.77-1.41.77-2.37.013-.967-.197-1.77-.63-2.41-.433-.64-1.043-1.123-1.83-1.45-.787-.32-1.707-.48-2.76-.48-1.053 0-1.97.16-2.75.48-.773.32-1.377.8-1.81 1.44-.433.647-.657 1.453-.67 2.42-.007.727.123 1.363.39 1.91.273.547.683.993 1.23 1.34.553.347 1.243.58 2.07.7v-2.54h1.89v5.1a5.482 5.482 0 01-.47.03c-.207.007-.33.01-.37.01-1.36 0-2.57-.27-3.63-.81a5.985 5.985 0 01-2.48-2.3c-.6-1-.9-2.197-.9-3.59zm.3 8.709h14.4v9.3h-2.26v-6.89H9.59v5.69H7.33v-5.69H3.26v6.89H1v-9.3zM.7 93.798c0-1.44.313-2.674.94-3.7.633-1.027 1.513-1.817 2.64-2.37 1.127-.547 2.433-.82 3.92-.82s2.793.273 3.92.82c1.127.553 2.003 1.343 2.63 2.37.633 1.026.95 2.26.95 3.7 0 1.66-.417 3.043-1.25 4.15-.827 1.106-1.943 1.883-3.35 2.33l-.67-2.43c.94-.28 1.673-.757 2.2-1.43.533-.674.8-1.547.8-2.62 0-.967-.217-1.774-.65-2.42-.433-.64-1.043-1.124-1.83-1.45-.78-.32-1.697-.484-2.75-.49-1.053 0-1.973.16-2.76.48-.78.326-1.387.813-1.82 1.46-.433.646-.65 1.453-.65 2.42 0 1.073.267 1.946.8 2.62.533.673 1.267 1.15 2.2 1.43l-.67 2.43c-1.407-.447-2.527-1.224-3.36-2.33-.827-1.107-1.24-2.49-1.24-4.15zm.3 8.675h14.4v5.95c0 .14-.007.32-.02.54-.007.22-.027.424-.06.61-.127.834-.403 1.52-.83 2.06-.427.547-.967.95-1.62 1.21-.647.267-1.367.4-2.16.4-1.173 0-2.183-.296-3.03-.89-.84-.593-1.36-1.503-1.56-2.73l-.09-1.03v-3.71H1v-2.41zm0 8.27l5.86-2.84.54 2.45-6.4 3.12v-2.73zm7.28-5.86v3.44c0 .134.007.284.02.45.013.167.04.32.08.46.1.4.277.714.53.94.253.234.54.397.86.49.32.1.633.15.94.15.307 0 .62-.05.94-.15.327-.093.617-.256.87-.49.253-.226.43-.54.53-.94.04-.14.063-.293.07-.46.013-.166.02-.316.02-.45v-3.44H8.28zM1 115.677h14.4v9.3h-2.26v-6.89H9.59v5.69H7.33v-5.69H3.26v6.89H1v-9.3zm0 10.7l14.4 4.54v3.53L1 138.987v-2.48l12.92-4.12v.54L1 128.857v-2.48zm3.12 2.53h2.25v7.56H4.12v-7.56zM1 143.063h12.14v-4.66h2.26v11.73h-2.26v-4.66H1v-2.41zm0 8.869h14.4v2.41H1v-2.41zm0 8.645l14.4-4.54v2.48l-12.06 3.8 12.06 3.85v2.48L1 164.107v-3.53zm0 9.573h14.4v9.3h-2.26v-6.89H9.59v5.69H7.33v-5.69H3.26v6.89H1v-9.3zm-.3 21.793c0-1.44.313-2.673.94-3.7.633-1.027 1.513-1.817 2.64-2.37 1.127-.547 2.433-.82 3.92-.82s2.793.273 3.92.82c1.127.553 2.003 1.343 2.63 2.37.633 1.027.95 2.26.95 3.7 0 1.66-.417 3.043-1.25 4.15-.827 1.107-1.943 1.883-3.35 2.33l-.67-2.43c.94-.28 1.673-.757 2.2-1.43.533-.673.8-1.547.8-2.62 0-.967-.217-1.773-.65-2.42-.433-.64-1.043-1.123-1.83-1.45-.78-.32-1.697-.483-2.75-.49-1.053 0-1.973.16-2.76.48-.78.327-1.387.813-1.82 1.46-.433.647-.65 1.453-.65 2.42 0 1.073.267 1.947.8 2.62s1.267 1.15 2.2 1.43l-.67 2.43c-1.407-.447-2.527-1.223-3.36-2.33-.827-1.107-1.24-2.49-1.24-4.15zm0 14.766c0-1.44.313-2.674.94-3.7.633-1.027 1.513-1.817 2.64-2.37 1.127-.547 2.433-.82 3.92-.82s2.793.273 3.92.82c1.127.553 2.003 1.343 2.63 2.37.633 1.026.95 2.26.95 3.7 0 1.44-.317 2.673-.95 3.7-.627 1.033-1.503 1.823-2.63 2.37-1.127.553-2.433.83-3.92.83s-2.793-.277-3.92-.83c-1.127-.547-2.007-1.337-2.64-2.37-.627-1.027-.94-2.26-.94-3.7zm2.27 0c-.007.966.207 1.77.64 2.41.433.646 1.043 1.13 1.83 1.45.787.326 1.707.49 2.76.49 1.053 0 1.967-.164 2.74-.49.78-.32 1.387-.804 1.82-1.45.433-.64.657-1.444.67-2.41.007-.967-.207-1.77-.64-2.41-.433-.64-1.043-1.124-1.83-1.45-.787-.32-1.707-.48-2.76-.48-1.053 0-1.97.16-2.75.48-.773.32-1.377.8-1.81 1.44-.433.646-.657 1.453-.67 2.42z"
          fill="#fff"
        />
      </svg>
    )
  }


const LinesTwo = [
    "Only Klaviyo",
    "E-Commerce",
    "Email & SMS"
]

const Hero = () => {


    gsap.registerPlugin(ScrollTrigger);


    const onCompleted = () => {
        gsap.to(".top-lines span", {
            duration: 1,
            y: "100%",
            opacity: 0,
            stagger: 0,
            ease: "power4.out",
            scrollTrigger: {
                trigger: '.hero-banner',
                start: "top",
                end: "bottom",
                scrub: 1

            }
        })
    }


    useLayoutEffect(() => {
        
        // trigger in 600ms


            const tl = gsap.timeline(
                {
                    onComplete: onCompleted
                }
            )


            tl.fromTo(".bg-backdrop", {translateY: 0}, {translateY: "-100%", ease: "power2.inOut", duration: 1})

            tl.fromTo(".top-lines span", 
            { y: `100%`, opacity: 0 }, 
            { y: 0, opacity: 1, duration: 1, stagger: 0.2, ease: "power4.out", delay: 0.5 }
            );   

            tl.fromTo(".bottom-lines span",

            { y: `100%`, opacity: 0 },
            { y: 0, opacity: 1, duration: 1, stagger: 0.2, ease: "power4.out", delay: 0 }
            );
        



    }, [])


    return(
        <section className={`h-screen lg:h-fit p-8 max-w-full overflow-x-hidden uppercase flex flex-col justify-between font-bold bg-[#FF8A00] hero-banner`}>


            <div className="bg-backdrop absolute inset-0 bg-black w-full h-full">

            </div>

            <div className="flex flex-row justify-between z-[5]">

                <div className='h2 lg:space-y-2'>

                    {Lines.map((line, index) => {
                        return(
                            <h2 key={`line-${index}`} className='top-lines overflow-hidden'>
                                <span className="inline-block">{line}</span>
                            </h2>
                        )
                    })}

                </div>

                <div className="hidden lg:block">
                    
                    <h1 className='w-8'>
                        <Logo/>
                        <span className="u-visually-hidden">Orange Creative Co</span>
                    </h1>

                </div>

            </div>

            <div className="z-[5] pb-24 lg:pb-0 relative">

                <div className="absolute left-0 bottom-24 lg:hidden">
                    <div className='w-4'>                    <Logo/></div>
                </div>

                <div className='h2 text-right lg:space-y-2 flex flex-col'>
                    {LinesTwo.map((line, index) => {
                        return(
                            <p className='bottom-lines overflow-hidden' key={`line-2-${index}`} >
                                <span className='inline-block'>
                                    {line}<br/>
                                </span>
                            </p>
                        )})}
                </div>

            </div>

           


        </section>
    )
}

export default Hero;